// @flow

import PropTypes from 'prop-types';
import React from 'react';
import bemify, { toModifiers } from 'bemify-js';

import AccountInfo from 'app/common/components/AccountInfo';
import Icon from 'app/common/components/Icon';
import { Div } from 'app/common/components/AccessibleElement';
import 'app/common/components/AccountDropdownToggler.scss';

const bem = bemify('account-dropdown-toggler');

const AccountDropdownToggler = (props: Object) => (
  <Div
    className={bem(toModifiers(props.kind), props.className)}
    onClick={props.onClick}
  >
    <AccountInfo {...props} />
    {props.hideArrow === true ? null : (
      <Icon className={bem('__arrow')} type="arrow-down" />
    )}
  </Div>
);

AccountDropdownToggler.propTypes = {
  accountId: PropTypes.number,
  meta: PropTypes.string,
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  hideArrow: PropTypes.bool,
  hideDetails: PropTypes.bool,
};

export default AccountDropdownToggler;
